import styled from 'styled-components';

export const FormContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 24px 0;
`;

export const FormField = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const Label = styled.label`
	font-size: 14px;
	font-weight: 600;
	color: #222;
`;

export const Input = styled.input`
	padding: 12px 14px;
	border-radius: 8px;
	border: 1.5px solid #e5e5e5;
	background-color: #fff;
	color: #222;
	font-size: 14px;
	transition: border-color 0.2s, box-shadow 0.2s;

	&::placeholder {
		color: #888;
	}

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.colors.whitePearl};
		box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.whitePearl}20;
	}
`;

export const TextArea = styled.textarea`
	padding: 12px 14px;
	border-radius: 8px;
	border: 1.5px solid #e5e5e5;
	background-color: #fff;
	color: #222;
	font-size: 14px;
	min-height: 80px;
	resize: vertical;
	font-family: inherit;
	transition: border-color 0.2s, box-shadow 0.2s;

	&::placeholder {
		color: #888;
	}

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.colors.whitePearl};
		box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.whitePearl}20;
	}
`;

export const ColorPickerWrapper = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
`;

export const ColorInput = styled.input`
	width: 60px;
	height: 40px;
	border-radius: 8px;
	border: 1.5px solid #e5e5e5;
	cursor: pointer;
	background-color: #fff;
`;

export const ColorPreview = styled.div<{ $color: string }>`
	width: 100px;
	height: 40px;
	border-radius: 8px;
	background-color: ${({ $color }) => $color};
	border: 1.5px solid #e5e5e5;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
`;
